<template>
    <div>
        <div class="row" v-if="hasProfilePermissions">
            <div class="col-lg-12">
                <h3>Payment Options</h3>
                <p>Make payments with your Credit Card on file. Servers Australia also accepts payments within PayPal’s live secure gateway system.</p>

                <!-- Has Services -->
                <div class="row pt-1" v-if="!ready">
                    <div class="col">
                        <sau-loading>
                            <template slot="message">Fetching Payment Options</template>
                        </sau-loading>
                    </div>
                </div>
                <div class="row pt-1" v-else>
                    <div class="col">
                        <sau-utility-payment-methods></sau-utility-payment-methods>
                    </div>
                </div>

            </div>
        </div>

        <div class="row" v-if="!hasProfilePermissions">
            <sau-request-permission></sau-request-permission>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hasProfilePermissions: false,
            ready: false
        };
    },
    mounted() {
        this.hasProfilePermissions = this.userDetails.whmcs_contact_id ? this.userDetails.permissions.split(",").indexOf('profile') > -1 : true;

        let paypalBA = this.getPaypalBAState().then(response => {
            this.$store.commit('paypalActiveBAOnFile', response.data.data.baState);
            this.$store.commit('paypalActiveBAEmail', response.data.data.baEmail);

        });

       this.ready = true;
    },
};
</script>
<style>
</style>
